// client/extensions/Paragraph.ts
import { DesignSystem } from "@adornis/chemistry/elements/theming/design.js";
import { mergeAttributes } from "@tiptap/core";
import TiptapParagraph from "@tiptap/extension-paragraph";
var Paragraph = (tagName = "text") => ({
  styles: ({ host }) => [
    {
      "[paragraph]": { marginBlockStart: "1em", marginBlockEnd: "1em" }
    }
  ],
  extensions: [
    TiptapParagraph.extend({
      renderHTML({ HTMLAttributes }) {
        return [`${DesignSystem.prefix}-${tagName}`, mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
      },
      parseHTML() {
        return [{ tag: `x-${tagName}` }, { tag: `${DesignSystem.prefix}-${tagName}` }];
      },
      addAttributes() {
        return {
          ...this.parent?.(),
          paragraph: {
            default: ""
          }
        };
      }
    })
  ]
});
export {
  Paragraph
};
